import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import Container from "./Container";
import Header from "./Header";
import HeaderNav from "./HeaderNav";
import HeaderTitle from "./HeaderTitle";
import Body from "./Body";
import BodyTitle from "./BodyTitle";
import Footer from "./Footer";
import FooterNav from "./FooterNav";
import CloseButton from "./CloseButton";
import IconX from "../Icon/IconX";
var propTypes = {
  /** Title that appears in the top header of dialog */
  dialogTitle: PropTypes.node,

  /** Optional place to use <NavStepper> */
  navStepper: PropTypes.node,

  /** Option place to add an <Banner> */
  banner: PropTypes.node,

  /** Optional body props to be passed to the body container element */
  bodyProps: PropTypes.object,

  /** Optional body styles */
  bodyStyle: PropTypes.objectOf(PropTypes.string),

  /** Optional title that appears at the top of the body */
  bodyTitle: PropTypes.node,
  body: PropTypes.node,

  /** Meant for buttons and optional NavStepper */
  footer: PropTypes.node,

  /** functionality to execute upon close button click */
  onClose: PropTypes.func,

  /** functionality to execute upon escape */
  onEscape: PropTypes.func,

  /** allows dark theme to be applied */
  theme: PropTypes.shape({
    dialogFullScreen: PropTypes.oneOf(['dark'])
  })
};
var defaultProps = {
  theme: {}
};
export function DialogFullScreen(_ref) {
  var banner = _ref.banner,
      body = _ref.body,
      bodyProps = _ref.bodyProps,
      bodyStyle = _ref.bodyStyle,
      bodyTitle = _ref.bodyTitle,
      dialogTitle = _ref.dialogTitle,
      footer = _ref.footer,
      navStepper = _ref.navStepper,
      onClose = _ref.onClose,
      onEscape = _ref.onEscape,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["banner", "body", "bodyProps", "bodyStyle", "bodyTitle", "dialogTitle", "footer", "navStepper", "onClose", "onEscape", "theme"]);

  if (onEscape) {
    useEffect(function () {
      var onKeydown = function onKeydown(event) {
        if (event.keyCode === 27) {
          onEscape(event);
        }
      };

      window.addEventListener('keydown', onKeydown, true);
      return function cleanup() {
        window.removeEventListener('keydown', onKeydown, true);
      };
    });
  }

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement(Container, props, banner, dialogTitle && React.createElement(Header, null, React.createElement(HeaderTitle, null, dialogTitle), navStepper && React.createElement(HeaderNav, null, navStepper), onClose && React.createElement(CloseButton, {
    onClick: onClose,
    "aria-label": "Close"
  }, React.createElement(IconX, {
    "aria-hidden": "true"
  }))), React.createElement(Body, Object.assign({
    style: bodyStyle
  }, bodyProps), bodyTitle && React.createElement(BodyTitle, null, bodyTitle), body), React.createElement(Footer, null, navStepper && React.createElement(FooterNav, null, navStepper), footer)));
}
DialogFullScreen.propTypes = propTypes;
DialogFullScreen.defaultProps = defaultProps;
DialogFullScreen.darkTheme = {
  dialogFullScreen: 'dark'
};
export default DialogFullScreen;